@use "../../styles/breakpoint.module.scss" as *;

.eyebrow {
    composes: fontB20 from "../../styles/typography.module.scss";
    font-weight: 800;
    margin: 0 0 var(--spacer-16) 0;
}

.headline {
    composes: fontHB64 from "../../styles/typography.module.scss";
    flex: 1;
    margin: 0 0 var(--spacer-24) 0;
}

.body {
    composes: fontP20 from "../../styles/typography.module.scss";
    margin: 0 0 var(--spacer-32) 0;

    @media ($below-mobile) {
        font-size: 16px;
    }
}

.cta {
    margin-top: auto;
}
